import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type UISignal from "app/pages/sales-intelligence/sub-modules/signals/models/view/UISignal";

export const getTrackingSignalsID = (signals: ReadonlyArray<UISignal<SignalFilters>>): string => {
    if (signals.length === 0) {
        return "no signals";
    }

    if (signals.length > 1) {
        return "any signal";
    }

    return signals[0].template.alias;
};

export const getSignalsCountTrackingBucket = (signalsCount: number): string => {
    switch (true) {
        case signalsCount < 1:
            return "no signals";
        case signalsCount <= 5:
            return "1 - 5 signals";
        case signalsCount <= 15:
            return "6 - 15 signals";
        default:
            return "more than 15 signals";
    }
};
